(() => {
  function initialize(scope = document) {
    scope.querySelectorAll('[data-story-section]').forEach(section => {
      if (section.dataset.storyReady) return;
      section.dataset.storyReady = 'true';
      const templates = [...section.querySelectorAll('[data-story-template]')];
      const dialog = section.querySelector('dialog');
      const stage = section.querySelector('[data-story-stage]');
      let current = 0;
      let opener;
      const stop = () => dialog.querySelectorAll('video').forEach(video => video.pause());
      function show(index) {
        if (!templates.length) return;
        stop();
        current = (index + templates.length) % templates.length;
        stage.replaceChildren(templates[current].content.cloneNode(true));
        const title = stage.querySelector('.story-panel-title');
        title.id = `StoryTitle-${section.closest('[id]')?.id || 'gallery'}`;
        dialog.setAttribute('aria-labelledby', title.id);
        const related = stage.querySelector('[data-related]');
        for (let offset = 1; offset < Math.min(3, templates.length); offset++) {
          const next = (current + offset) % templates.length;
          const original = section.querySelector(`[data-story-open="${next}"]`);
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.storyRelated = next;
          const image = original.querySelector('img').cloneNode();
          image.alt = '';
          const label = document.createElement('span');
          label.textContent = original.querySelector('strong').textContent;
          button.append(image, label);
          related.append(button);
        }
        section.querySelector('[data-story-position]').textContent = `${current + 1} / ${templates.length}`;
        if (!dialog.open) { dialog.showModal(); document.body.classList.add('story-panel-open'); }
        dialog.querySelector('.story-close').focus();
      }
      section.addEventListener('click', event => {
        const open = event.target.closest('[data-story-open]');
        if (open) { opener = open; show(Number(open.dataset.storyOpen)); }
        const step = event.target.closest('[data-story-step]');
        if (step) show(current + Number(step.dataset.storyStep));
        const related = event.target.closest('[data-story-related]');
        if (related) show(Number(related.dataset.storyRelated));
        if (event.target.closest('.story-close') || event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => { stop(); document.body.classList.remove('story-panel-open'); opener?.focus(); });
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

